import { dashState, dashMutations, dashActions, dashGetters } from "./dashboard.js";
import { soliState, soliMutations, soliActions } from "./solicitudes.js";
import { EppState, EppMutations, EppActions, EppGetters } from "./epp.js";
import { ReportActions } from "./Report.js";
import { BodegaState, BodegaMutations, BodegaActions } from "./Bodega.js";
import { JefesState, JefesMutations, JefesActions } from "./Jefes.js";
import { EncargadosState, EncargadosMutations, EncargadosActions } from "./Encargados.js";
import { AutomatizacionState, AutomatizacionMutations, AutomatizacionActions } from "./Automatizacion.js";
import { centroState, centroMutations, centroActions, centroGetters} from "./CentroCosto.js";
import { PermisosState, PermisosMutations, PermisosActions, PermisosGetters } from "./Permisos.js";

export default {
  namespaced: true,
  state: {
    ...dashState,
    ...soliState,
    ...EppState,
    ...BodegaState,
    ...JefesState,
    ...EncargadosState,
      ...AutomatizacionState,
    ...centroState,
    ...PermisosState,
  },

  mutations: {
    ...dashMutations,
    ...soliMutations,
    ...EppMutations,
    ...BodegaMutations,
    ...JefesMutations,
    ...EncargadosMutations,
    ...AutomatizacionMutations,
    ...centroMutations,
    ...PermisosMutations,
  },

  actions: {
    ...dashActions,
    ...soliActions,
    ...EppActions,
    ...ReportActions,
    ...BodegaActions,
    ...JefesActions,
    ...EncargadosActions,
    ...AutomatizacionActions,
    ...centroActions,
    ...PermisosActions,
  },

  getters: {
    ...dashGetters,
    ...centroGetters,
    ...EppGetters,
    ...PermisosGetters,
  },
};
